import BooleanRen from "csi/heading/Boolean";
import declare from "dojo/_base/declare";

const DataSheetItemsImportConfigurationActive = declare(BooleanRen, {
	/**
	 * @override
	 * Enable drag-fill
	 */
	canCopy(ctxCopy, h) {
		return true;
	},

});

export = DataSheetItemsImportConfigurationActive;